import { render, staticRenderFns } from "./VideoStream.vue?vue&type=template&id=1738bf4a&scoped=true&"
import script from "./VideoStream.vue?vue&type=script&lang=js&"
export * from "./VideoStream.vue?vue&type=script&lang=js&"
import style0 from "./VideoStream.vue?vue&type=style&index=0&id=1738bf4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1738bf4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1738bf4a')) {
      api.createRecord('1738bf4a', component.options)
    } else {
      api.reload('1738bf4a', component.options)
    }
    module.hot.accept("./VideoStream.vue?vue&type=template&id=1738bf4a&scoped=true&", function () {
      api.rerender('1738bf4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VideoStream.vue"
export default component.exports